import React from 'react';
import Footer from '../components/Footer/Footer'
import Bookings from '../components/Bookings/Bookings'
import './pagestyles/Portfolio.css'
import P1 from '../img/PortImg1.jpg'
import P2 from '../img/PortImg2.jpg'
import P3 from '../img/PortImg3.jpg'
import P4 from '../img/PortImg4.jpg'
import P5 from '../img/PortImg5.jpg'
import P6 from '../img/PortImg6.jpg'
import P7 from '../img/PortImg7.jpg'
import P8 from '../img/PortImg8.jpg'
import CadenceCover from '../img/CadenceCover.jpg'

function Portfolio() {
  const projects = [
    {
      id: 1,
      title: 'The Epistel Project',
      artist: 'by IMRSQD',
      credit: 'Credit: Record + Mix + Master [All Songs]',
      link: 'https://open.spotify.com/album/1bA4zwAVhRtQdM7pRx2Wpx',
      image: P1,
    },
    {
      id: 2,
      title: 'Praises 24/7',
      artist: 'by Chiwaz ft Avery Doreen',
      credit: 'Credit: Mix + Master [Single]',
      link: 'https://open.spotify.com/track/00xGlTvorRxhTAMacmyABc?si=c21b9beb51734db1',
      image: P2,
    },
    {
      id: 3,
      title: 'Freedom',
      artist: 'by Chiwaz feat. Various Artists',
      credit: 'Credit: Mix + Master [Single]',
      link: 'https://open.spotify.com/track/228eAjn9UfCe8PcNJ79TMN?si=207e81ad936447ca',
      image: P3,
    },
    {
      id: 4,
      title: 'Crimson',
      artist: 'by IMRSQD ft Sam Rivera',
      credit: 'Credit: (Some) Recordings + Mix + Master [Single]',
      link: 'https://open.spotify.com/album/4vwTYyHuZpiEb6z1HJjQpS?si=w5nq1BO8ToyxSxg2g9REOA',
      image: P4,
    },
    {
      id: 5,
      title: 'Ma I Made It',
      artist: 'by IMRSQD',
      credit: 'Credit: Record + Mix + Master [Single]',
      link: 'https://open.spotify.com/album/3BqbX60OeR6bGnyCJ4bUkQ?si=dzW6lvAVSzScIJFSkxXyRg',
      image: P5,
    },
    {
      id: 6,
      title: 'Tempest',
      artist: 'by IMRSQD',
      credit: 'Credit: Record + Mix + Master [Single]',
      link: 'https://open.spotify.com/track/25jaqTfAg4qNCht0Hut0tI?si=6cd9d22092444f3f',
      image: P6,
    },
    {
      id: 7,
      title: 'Walking Zoo',
      artist: 'by Asham',
      credit: 'Credit: Record + Mix + Master [Single]',
      link: 'https://open.spotify.com/track/2l9tg89matJIAwyi3ObH6z?si=9e06fda7c6944d87',
      image: P7,
    },
    {
      id: 8,
      title: "Daddy's Little Girl",
      artist: 'by Nasim',
      credit: 'Credit: Record + Mix + Master [Single]',
      link: 'https://open.spotify.com/track/1z9A20oWx4V8AeToIyqnFv?si=08c0d0d934d8473b',
      image: P8,
    },
    {
      id: 9,
      title: 'Cadence',
      artist: 'by Kojo Dave',
      credit: 'Credit: Mix + Master + Co-Producer [Single]',
      link: 'https://open.spotify.com/album/7CGm5SU6LknHNVNn5AL3zf?si=cM2qNFMiSJ-UwkOSfRdZpw',
      image: CadenceCover,
    },
  ];

  return (
    <div>
      <h1 className='h'>Portfolio</h1>
      <h1 className='hsub'>Some projects Kushim was involved in</h1>
      <div className='allPort'>
        <div className='port'>
          {projects.map(({ id, title, artist, credit, link, image }) => (
            <div className='portBox' key={id}>
              <div className='cdCase'>
                <a className='cdSpine' href={link} target='_blank' rel='noopener noreferrer' aria-label={`Open ${title}`}>
                  <span>Play</span>
                </a>
                <div className='cdFront'>
                  <img src={image} alt={title} />
                </div>
              </div>

              <div className='portBoxTextStyle'>
                <strong>{title}</strong>
                <span>{artist}</span>
                <small>{credit}</small>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div id="booking-form">
        <Bookings />
      </div>
      <Footer />
    </div>
  );
}

export default Portfolio